// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1h1T4","topBottomGutter":"Layout_topBottomGutter__3ZRfm"};